import { render } from "./EditPlantJournalForSystem.vue?vue&type=template&id=5a8201d7"
import script from "./EditPlantJournalForSystem.vue?vue&type=script&lang=js"
export * from "./EditPlantJournalForSystem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__